import { render } from "./DepartmentManage.vue?vue&type=template&id=53f192c4"
import script from "./DepartmentManage.vue?vue&type=script&lang=js"
export * from "./DepartmentManage.vue?vue&type=script&lang=js"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__